<template>
  <div>
    <leftSideBar :anchor="anchor"></leftSideBar>
    <SideBar></SideBar>
    <div class="page-box">
      <div class="secure-block">

        <div class="rescue-bigtitle2"
            id="why">
          <div>定期体检</div>
          <div>早发现，早治疗</div>
        </div>
        <h4 class="rescue-title">为什么要做定期体检</h4>
        <p class="para">随着人类平均寿命的延长，人的一生中患癌的概率已经达到50%左右，就是每两个人当中就会有一人可能罹患癌症。癌症和心血管疾病的发病年龄不仅趋于年轻化，随着年龄的增加，发病率也会极速升高。
        </p>
        <p class="para">但是大多数疾病的早期阶段是没有任何症状的，病情发展到中晚期才会有症状出现。</p>
        <img class="img-center"
             style="width:674px; height:408px; margin-top:35px; margin-bottom:40px;"
             :src="bodycheck1"
             alt="">
        <p class="para">通过定期的精密体检，既可以早期发现癌症和心脑血管疾病，也可以预防生活习惯病。</p>
        <p class="para">特别是大肠癌、胃癌、肺癌、乳腺癌、前列腺癌等主要的癌症，通过早发现早治疗，可以大幅提高患者的生存率（如表所示）和生活质量。一般认为1/3的癌是可以预防的，1/3的癌是可以通过体检早期发现的，及时治疗达到良好的预后效果。
        </p>
        <p class="para"
           style="margin-bottom: 49px;">引发心脏疾病和脑血管疾病的主要因素是动脉硬化，而导致动脉硬化的主要因素是高血压、脂质异常、糖尿病、肥胖、吸烟等大家所熟悉的常见疾病。这些常见的疾病，通过精密体检早发现的话，可以通过饮食和运动等生活习惯的改变而改善。
        </p>
        <img class="img-center"
             style="margin-bottom:98px;"
             :src="bodycheck8"
             alt="">

        <h4 class="rescue-title"
            id="six">日本体检六大优势</h4>
        <div class="check-block">
          <h5 class="check-title">
            <span>优势1</span>历史悠久 体系完整</h5>
          <div class="check-con">
            <div style="width:563px;">
              <p>最早于1954年开始短期住院精密体检，已有半个多世纪的历史。拥有完整的体检体系和标准的体检项目。</p>
              <p>由1959年创立的JAPAN SOCIETY OF NINGEN DOCK和1973年创立的Japan Society of Health Evaluation and Promotion两大学会制定标准，推广认证制度，确保质量。
              </p>
            </div>
          </div>
        </div>
        <div class="check-block">
          <h5 class="check-title">
            <span>优势2</span>日式服务 人性化服务</h5>
          <div class="check-con">
            <div>
              <p>包括医生在内的所有的工作人员全程微笑服务，让您享受体检过程。</p>
              <p>超声波检查用的耦合剂温和无凉感，检查后还会用干净的毛巾帮您擦净。</p>
              <p>每个项目检查结束后，都会有医护人员告诉您下一个检查项目或有专人带您过去。</p>
            </div>
            <img :src="bodycheck2"
                 alt="">
          </div>
        </div>
        <div class="check-block">
          <h5 class="check-title">
            <span>优势3</span>专业技术高 检查精度高</h5>
          <div class="check-con">
            <div>
              <p>心电图、超声波、肺功能等检查由取得国家资格认证的临床检查技师进行。</p>
              <p>X光、CT、PET、乳腺钼靶等检查由取得国家资格认证的放射线技师进行。</p>
              <p>无论设备大小，定期进行维护，校准精度，确保您的检查准确无误。</p>
            </div>
          </div>
        </div>
        <div class="check-block">
          <h5 class="check-title">
            <span>优势4</span>影像读片技术高</h5>
          <div class="check-con">
            <div>
              <p>对于CT、核磁、PET等影像检查，采取2人读片制，大程度的降低误诊率。</p>
              <p>2位专业的读片医生，分别读片诊断后，诊断结果一致才签发报告。</p>
            </div>
            <img :src="bodycheck3"
                 alt="">
          </div>
        </div>
        <div class="check-block">
          <h5 class="check-title">
            <span>优势5</span>私密性好 体检环境好</h5>
          <div class="check-con">
            <div style="width:563px;">
              <p>很多体检中心，为了保护隐私会以号码代替姓名。部分高端体检中心设有专门的女士检查区域，包括医生，护士在内的所有医护人员均为女性，更不会有无关人员随意出入。
              </p>
              <p>采取完全预约制，为了保证服务质量，严格控制每天的体检人数。每个检查项目按体检安排好的流程一次进行，不会出现拥挤、排长队的问题。
              </p>
            </div>
          </div>
        </div>
        <div class="check-block">
          <h5 class="check-title">
            <span>优势6</span>地缘优势 体检观光两不误</h5>
          <div class="check-con">
            <div style="width:563px;">
              <p>与国内时差只有1小时，从国内飞日本只有2-4小时的航程，和国内旅游没什么差别。</p>
              <p>日本文化和习惯与中国相近，到了日本看到汉字也会十分亲切。享受日本医疗服务的同时，可以体验日本文化、享受日本美食。
              </p>
            </div>
            <img :src="bodycheck4"
                 style="width:232px;height:155px;"
                 alt="">
          </div>
        </div>

        <h4 class="rescue-title" id="wmj">为什么找威马捷？</h4>
        <p class="para">威马捷自2011年开展赴日医疗协调服务以来，已积攒了近十年的海外医疗协调服务经验。凭借与日本各大医疗机构长期密切的合作关系，结合中国客户特有的需求，与数十家体检机构展开合作，开发体检套餐。可根据客户的需求，精准地推荐体检项目和体检机构。</p>
        <img class="img-center"
             style="width:938px; height:517px; margin-top:38px; margin-bottom:96px;"
             :src="bodycheck5"
             alt="">

        <h4 class="rescue-title"
            id="recommend">推荐检查</h4>
        <div class="check-recommand">
          <img :src="bodycheck6"
               style="width:881px; height: 570px; margin:18px auto 93px;"
               alt="">
          <!-- <ul>
                    <li><span>头颈部</span>  ・・・头部RI/MRA</li>
                    <li><span>眼</span>      ・・・视力，眼压，眼底</li>
                    <li><span>耳 </span>     ・・・听力</li>
                    <li><span>甲状腺</span>  ・・・超声波，激素</li>
                    <li><span>食  道</span>  ・・・胃镜</li>
                    <li><span>胃 </span>     ・・・胃镜，幽门螺旋杆菌抗体</li>
                    <li><span>十二指肠</span>・・・胃镜</li>
                    <li><span>肺  </span>    ・・・X光，CT，肺功能</li>
                    <li><span>心脏 </span>   ・・・心电图，X光，心脏超声，动态心电图</li>
                    <li><span>血管 </span>   ・・・CAVI/ABI，，颈动脉超声，头部MRI/MRA</li>
                    <li><span>肝胆胰</span>  ・・・ 超声波，上腹部MRI，MRCP，血检</li>
                    <li><span>肾  </span>    ・・・超声波，血检，尿检</li>
                    <li><span>大肠</span>    ・・・大便隐血，肠镜，大肠CT</li>
                    <li><span>乳腺</span>    ・・・超声波（35岁以下），钼靶（35岁以上）</li>
                    <li><span>子宫 </span>   ・・・妇科诊察，阴道超声，阴道镜，HPV，细胞诊，盆骨MRI</li>
                    <li><span>前列腺</span>  ・・・PSA，盆骨MRI</li>
                    <li><span>骨  </span>    ・・・骨密度</li>
                    <li><span>全身</span>    ・・・PET/CT</li>
                </ul> -->
        </div>

        <h4 class="rescue-title"
            id="sch">体检流程</h4>
        <img class="img-center"
             :src="bodycheck7"
             alt="">

      </div>
      <div class="main"
           style="width:980px;">

        <h5 class="secure-title title01"
            id="hospital">合作医院
          <router-link to="/hospitalList/jmtj/0"
                       target="_blank">更多 &gt;</router-link>
        </h5>
        <div class="secure-hospital">
          <router-link v-for="(hos, index) in hospitals"
                       :to="'/hospitalInfo/' + hos.id"
                       target="_blank"
                       :key="index">
            <img class="hospital-img"
                 :src="baseURL + hos.hospital_img"
                 alt="">
            <div class="hospital-content">
              <h6 class="hospital-name"
                  v-html="hos.name"></h6>
              <p class="hospital-info">{{hos.easy_brief}}</p>
            </div>
          </router-link>
        </div>
        <h5 class="secure-title title02"
            id="cases"
            style="padding-top:70px;">服务案例
          <router-link to="/successCase/2"
                       target="_blank">更多 &gt;</router-link>
        </h5>
        <div class="fw-bg">
          <div class="medicine-case"
               v-for="(c,index) in cases"
               :key="index">
            <router-link target="_blank" :to="{name: 'successCaseDetail',params:{ id: c.id} }">
              <div class="case-info">
                <h5 class="case-info_text">{{c.title}}</h5>
                <p class="case-ill">
                  <span>疾病：{{c.disease_name}} </span>
                  <span class="b">{{c.alias}}<br/> {{c.age}} 岁</span>
                </p>
                <!-- <p class="case-topic">摘要： {{c.desc}}</p> -->
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bodycheck1 from "@/assets/images/medicine/bodycheck1.png"
import bodycheck2 from "@/assets/images/medicine/bodycheck2.jpg"
import bodycheck3 from "@/assets/images/medicine/bodycheck3.jpg"
import bodycheck4 from "@/assets/images/medicine/bodycheck4.jpg"
import bodycheck5 from "@/assets/images/medicine/bodycheck5.png"
import bodycheck6 from "@/assets/images/medicine/bodycheck6.jpg"
import bodycheck7 from "@/assets/images/medicine/bodycheck7.png"
import bodycheck8 from "@/assets/images/medicine/bodycheck8.png"
import leftSideBar from "@/components/LeftSideTitleBar.vue"
import SideBar from "@/components/SideBar"
import * as apis from '@/api/hospital'
import * as cases from '@/api/success'
import { baseURL } from "@/api/axios"
export default {
  data () {
    return {
      baseURL,
      bodycheck1,
      bodycheck2,
      bodycheck3,
      bodycheck4,
      bodycheck5,
      bodycheck6,
      bodycheck7,
      bodycheck8,
      anchor: [
        { title: '为什么要定期体检', id: 'why' },
        { title: '日本体检六大优势', id: 'six' },
        { title: '为什么找威马捷？', id: 'wmj' },
        { title: '推荐检查', id: 'recommend' },
        { title: '体检流程', id: 'sch' },
        { title: '合作医院', id: 'hospital' },
        { title: '服务案例', id: 'cases' },
      ],
      cases: [],
      hospitals: [],
    }
  },
  components: {
    leftSideBar,
    SideBar
  },
  mounted () {
    this.getHospitalList();
    this.getSuccessList();
  },
  methods: {
    async getHospitalList () {
      try {
        let data = {
          hospital_type_id: 2,
          //出国看病 3
          state_id: undefined,
          area_id: undefined,
          department_id: undefined,
          disease_id: [],
          keyword: undefined,
          page: 1
        }
        let res = await apis.getAllHospitalList(data);
        if (res.code == 200) {
          // console.log(res.data.data)
          let rs = res.data.data.map(item => {
            return {
              ...item,
              info: this.getSimpleText(item.easy_brief)
            }
          });
          if (rs.length > 6) {
            this.hospitals = rs.slice(0, 6);
          } else {
            this.hospitals = rs;
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getSuccessList () {
      try {
        let data = {
          page: 1,
          id: 0,
          disease_id: 0,
          type_id: 2
        }
        let res = await cases.getSuccessCaseList(data);
        if (res.code == 200) {
          this.cases = res.data.data.slice(0, 3);
        }
      } catch (e) {
        console.log(e)
      }
    },
    getSimpleText (html) {
      var re1 = new RegExp("<.+?>", "g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1, '');//执行替换成空字符
      return msg;
    },
    setDoctorName (name) {
      if (name) {
        return name.replace(/\n/g, "<br/>");
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
.bg {
  background: #fff;
  overflow: auto;
}

.title01 {
  // background-image: url("../assets/images/home/yy-icon.png");
  background: url('../assets/images/home/hzyy-icon.png') no-repeat 0 107px;
  background-size: 28px 28px;
  a {
    font-size: 24px;
  }
}
.title02 {
  background-image: url('../assets/images/home/fwal-icon.png');
  background-position: 0 70px;
  background-size: 28px 28px;
}
.bg-white {
  background: #fff;
  border-top: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
}
.secure-block {
  width: 980px;
  border: 1px solid #dcdcdc;
  background: #fff;
  padding: 26px;
  margin: 20px auto 50px;
}
.check-block {
  border: 1px solid #dfdfdf;
  margin-bottom: 30px;
}
.check-title {
  position: relative;
  background: #e9ebf4;
  height: 50px;
  font-size: 18px;
  line-height: 50px;
  padding-left: 112px;
  overflow: hidden;
  z-index: 9999;
  &::before {
    position: absolute;
    left: 130px;
    top: 0;
    display: block;
    content: '';
    width: 0;
    height: 0;
    border-width: 37px 0px 28px 25px;
    border-style: solid;
    border-color: #e9ebf4;
    transform: translateX(-50px) rotate(23deg);
    z-index: 9;
  }
  span {
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 96px;
    background: #ae1e10;
    color: #fff;
    text-align: center;
    text-indent: -10px;
  }
}
.check-con {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px;
  padding-bottom: 30px;
  p {
    font-size: 16px;
    color: #333;
    line-height: 32px;
  }
}
.para {
  font-size: 16px;
  color: #333130;
  line-height: 32px;
}
.img-center {
  display: block;
  margin: 0 auto;
}
.check-recommand {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  ul {
    li {
      font-size: 18px;
      color: #333130;
      line-height: 30px;
      span {
        display: inline-block;
        width: 80px;
      }
    }
  }
}
.hospital-info {
  -webkit-line-clamp: 3 !important;
}
.rescue-bigtitle2 {
  position: relative;
  width: 100%;
  height: 80px;
  background: url(data:image/png;base64,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) no-repeat center center;
  background-size: 100% 100%;
  color: #fff;
  font-size: 28px;
  /* line-height: 80px; */
  padding-left: 45px;
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 600;
}
</style>
